<template>
	<div>
		<div v-if="showAppDownload">
			<div class="cover-container  d-flex mx-auto flex-column text-center">
				<section class="inner container">
					<div class="center-contain">
						<h5 class="text-uppercase  mobile-intro-text">
							Watch ibakatv movies on your smartphone or tablet
						</h5>
						<p class="lead my-3">for better user experience</p>
					</div>
				</section>
				<section class="devices-container">
					<div class="container">
						<div class="center-contain">
							<img src="@/assets/img/PhoneMockup.png" class="divices" />

							<div class="mt-3 col-md-12 col-sm-12 d-flex justify-content-center">
								<p class="mr-2">
									<img src="@/assets/img/Google play logo.png" class="app-image"
										@click="gotoAppStore('google')" />
								</p>
								<p>
									<img src="@/assets/img/Apple Store logo.png" class="app-image"
										@click="gotoAppStore('apple')" />
								</p>
							</div>

							<div class="my-4 mobileweb-link">
								or
								<a class="gotoweb-link" @click="gotoMobileWebApp()">continue on the browser</a>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
		<div id="intro" v-if="!showAppDownload">
			<div class="cover-container d-flex mx-auto flex-column text-center">
				<header class="masthead mb-auto">
					<nav class="navbar navbar-expand-lg navbar-dark bg-transparent ">
						<div class="container">
							<a class="navbar-brand" href="/#/">
								<img src="../assets/img/logo.png" alt="Logo" />
							</a>
							<div class="my-2 my-lg-0">
								<button class="btn btn-light btn-sm my-2 my-sm-0" @click="gotoLogin">
									login
								</button>
							</div>
						</div>
					</nav>
				</header>
				<section class="inner container">
					<div class="center-contain">
						<h1 class="cover-heading">{{ globalConfig.landscreen_text1 }}</h1>
						<p class="lead my-4">
							{{ globalConfig.landscreen_text2 }}
						</p>
						<p class="lead my-4">
							<small>{{ globalConfig.landscreen_text3 }}</small>
						</p>
						<p class="lead">
							<a href="/#/login" class="btn btn-lg btn-light">{{ globalConfig.landscreen_btn_text }}
								<i class="fa fa-chevron-right rt" aria-hidden="true"></i></a>
						</p>
					</div>
				</section>
				<section class="devices-container">
					<div class="container">
						<div class="center-contain">
							<img src="@/assets/img/devices-mockup.png" class="divices" />
							<p class="lead my-4">
								<small>{{ globalConfig.landscreen_text4 }}</small>
							</p>
							<img src="@/assets/img/devices-name.png" class="mb-5" />
						</div>
					</div>
				</section>
			</div>
			<section class="movie-block">
				<div class="container">
					<div class="row justify-content-between">
						<div class="col-md-5 text-right">
							<h2>{{ globalConfig.landscreen_text5 }}</h2>
							<p>
								{{ globalConfig.landscreen_text6 }}
							</p>
							<a href="/#/login" class="btn btn-lg btn-primary">{{ globalConfig.landscreen_btn_text }}
								<i class="fa fa-chevron-right rt" aria-hidden="true"></i></a>
						</div>
						<div class="col-md-5">
							<img src="@/assets/img/movie-carousel.png" class="img-fluid" />
						</div>
					</div>
				</div>
			</section>
			<section class="laptop-block">
				<div class="container">
					<div class="row justify-content-between align-items-center">
						<div class="col-md-5">
							<img src="@/assets/img/laptop-screen.png" class="img-fluid" />
						</div>
						<div class="col-md-5">
							<h2>{{ globalConfig.landscreen_text7 }}</h2>
							<p>
								{{ globalConfig.landscreen_text8 }}
							</p>
						</div>
					</div>
				</div>
			</section>
			<div class="pricing-container d-flex mx-auto flex-column">
				<section class="inner container text-center">
					<div class="center-contain">
						<h1 class="pricing-heading">{{ globalConfig.landscreen_text9 }}</h1>
						<p class="lead my-4">
							{{ globalConfig.landscreen_text10 }}
						</p>
						<!-- <p class="lead my-5">
            <select
              class="form-control select-lg"
              id="exampleFormControlSelect1"
              v-model="currentPackage"
            >
              <option
                :value="item.id"
                v-for="(item, index) in packages"
                :key="index"
              >
                {{ item.title }}
              </option>
            </select>
          </p> -->
					</div>
				</section>
				<section class="price-data bg">
					<div class="container">
						<div class="card-deck">
							<div class="card" v-for="(card, index) in currentSubsList" :key="index">
								<div class="card-body">
									<p class="mb-4">{{ card.title }}</p>
									<p>
										<small>{{ card.currency }}</small>
									</p>
									<h1 class="mb-5">{{ card.price }}</h1>
									<a href="/#/signup" class="btn btn-primary mb-4">SELECT PLAN</a>
									<ul>
										<li>4GB data free</li>
										<li>14 days free subscription</li>
										<li>Unlimited movies and Tv shows</li>
										<li>Watch on your laptop, TV, phone and tablet</li>
										<li>Cancel anytime</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
			<section class="laptop-block p-0">
				<div class="container">
					<div class="row justify-content-between align-items-center">
						<div class="col-md-5 text-right">
							<h2 class="mb-4">
								{{ globalConfig.landscreen_text11 }}
							</h2>
							<a href="/#/login" class="btn btn-lg btn-primary">{{ globalConfig.intro_free_data_text }}
								<i class="fa fa-chevron-right rt" aria-hidden="true"></i></a>
						</div>
						<div class="col-md-5">
							<img src="@/assets/img/free-data.png" class="img-fluid" />
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import Header from "@/components/Header.vue";
import Packages from "@/pages/Packages.vue";

export default {
	name: "intro",
	watch: {
		currentPackage: function (val) {
			var currentSubs = this.getSubsById(val);
			this.currentPackage = currentSubs.id;
			this.currentSubsList = currentSubs.subscriptions;
		},
	},
	data() {
		return {
			items: [],
			nocontent: false,
			package: null,
			packages: null,
			currentPackage: null,
			currentSubsList: null,
			globalConfig: null,
			showAppDownload: false,
		};
	},
	components: {
		Packages,
		Header,
	},
	created() {
		// this.$store.commit("showdefaultnav", true);
		this.$store.commit("showdefaultFooter", true);
		this.packages = this.$store.state.packages;
		this.packages = this.packages.filter(
			(item) => item.metaData.special_plan != "true"
		);
		this.currentPackage = this.$store.state.packages[0].id;
		this.globalConfig = this.$store.getters.getGlobalConfigs;
		if (this.isPlatformMobile() == true) {
			this.showAppDownload = true;
		} else if (this.isPlatformTablet() == true) {
			this.showAppDownload = true;
		} else {
			this.showAppDownload = false;
		}
	},
	methods: {
		getpaymentHref(card) {
			return "/#/selectpayment-dsp/" + card.id + "/" + this.currentPackage;
		},
		getSubsById(pid) {
			var currentPackageObj = this.packages.find((ele) => ele.id == pid);
			return currentPackageObj;
		},
		gotoLogin() {
			this.$router.push("login");
		},
		isPlatformMobile() {
			let check = false;
			(function (a) {
				if (
					/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
						a
					) ||
					/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
						a.substr(0, 4)
					)
				)
					check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);

			return check;
		},
		isPlatformTablet() {
			return (function (a) {
				if (/ipad|android.+\d safari|tablet/i.test(a)) return true;
			})(navigator.userAgent || navigator.vendor || window.opera)
				? "true"
				: "false";
		},
		getText(val) {
			return this.$store.getters.getGlobalConfigs[val];
		},
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		gotoMobileWebApp() {
			this.gotoLogin()
		},
	},
	beforeCreate() {
		if (this.$store.state.user.logedin) {
			this.$router.push("/home");
		}
	},
	mounted() {
		window.scroll(0, 0);
	},
};
</script>

<style>
.app-image {
	cursor: pointer;
	width: 150px;
	object-fit: cover;
}

.mobileweb-link {
	font-size: 22px !important;
	font-weight: 500 !important;
	cursor: pointer;
}

.gotoweb-link {
	text-decoration: underline !important;
}

.mobile-intro-text {
	font-weight: 900 !important;
}
</style>
